export default {
    client: "Cliente",
    country: "Pais",
    in_case_of_doubts_about_the_operation_of_the_platform_points_or_any_information_not_related_to_the_content_of_the_courses_fill_out_the_form_to_contact_our_support_team_our_response_time_is_7_working_days: "En caso de dudas sobre el funcionamiento de la plataforma, los puntos o cualquier información, complete el formulario para ponerse en contacto con nuestro equipo de soporte.",
    subject: "Sujeto"
}